var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shield",
    transform: "translate(-534 -239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83179",
    "data-name": "Path 83179",
    d: "M23,0C40.851,0,46,5.149,46,23S40.851,46,23,46,0,40.851,0,23,5.149,0,23,0Z",
    transform: "translate(534 239)",
    fill: "#f2f3f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shield-2",
    "data-name": "shield",
    d: "M12,22.75a.75.75,0,0,1-.335-.079,21.87,21.87,0,0,1-4.158-2.856,14.826,14.826,0,0,1-2.895-3.328A8.515,8.515,0,0,1,3.25,12V5a.75.75,0,0,1,.487-.7l8-3a.75.75,0,0,1,.527,0l8,3a.75.75,0,0,1,.487.7v7a8.515,8.515,0,0,1-1.361,4.487,14.826,14.826,0,0,1-2.895,3.328,21.87,21.87,0,0,1-4.158,2.856A.75.75,0,0,1,12,22.75ZM4.75,5.52V12c0,4.8,5.78,8.33,7.25,9.149,1.469-.82,7.25-4.357,7.25-9.149V5.52L12,2.8Z",
    transform: "translate(545.5 250.5)",
    fill: "#636974"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/password_icon.98adfba47c58cab77fe5f6b64d9e5f3d.svg";
export { ForwardRef as ReactComponent };